import { render } from "./lightbox.vue?vue&type=template&id=616ae2c0"
import script from "./lightbox.vue?vue&type=script&lang=js"
export * from "./lightbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__